module.exports = __webpack_public_path__ + "img/collapse-right.21ec3f33.svg";